export enum Brands {
  Chevrolet = 0,
  Buick = 1,
  GMC = 2,
  Cadillac = 4
}
